var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cart_Icon",
    "data-name": "Cart Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M6,2.562,1.768,7.64A1,1,0,1,1,.232,6.36l5-6a1,1,0,0,1,1.536,0l5,6a1,1,0,0,1-1.536,1.28Z",
    transform: "translate(6 2)",
    fill: "#1235e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M12.5,12h-6a2.991,2.991,0,0,1-2.769-1.846L.077,1.384A1,1,0,0,1,1,0H18a1,1,0,0,1,.923,1.384l-3.654,8.77A2.991,2.991,0,0,1,12.5,12Zm-3-8a2,2,0,1,0,2,2A2,2,0,0,0,9.5,4Z",
    transform: "translate(2.5 9)",
    fill: "#1235e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.ff5742eb5250367a524fcaa065dd793a.svg";
export { ForwardRef as ReactComponent };